import { render, staticRenderFns } from "./BaseShare.vue?vue&type=template&id=492bdc2c&scoped=true&"
import script from "./BaseShare.vue?vue&type=script&lang=js&"
export * from "./BaseShare.vue?vue&type=script&lang=js&"
import style0 from "./BaseShare.vue?vue&type=style&index=0&id=492bdc2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492bdc2c",
  null
  
)

export default component.exports